import { render } from "./ClassList.vue?vue&type=template&id=ff6a395c&scoped=true"
import script from "./ClassList.vue?vue&type=script&lang=js"
export * from "./ClassList.vue?vue&type=script&lang=js"

import "./ClassList.vue?vue&type=style&index=0&id=ff6a395c&lang=scss"
import "./ClassList.vue?vue&type=style&index=1&id=ff6a395c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff6a395c"]])

export default __exports__